import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  systemIssuesService,
  type SystemIssuePendingAttachment,
} from '../../../services/systemIssuesService'
import { issueKey, myIssuesKey } from './useSystemIssues'

export const issueMessagesKey = (issueId: number) =>
  ['system-issues', 'messages', issueId] as const

export function useIssueMessages(issueId: number | null) {
  return useQuery(
    issueId ? issueMessagesKey(issueId) : ['system-issues', 'messages', 'idle'],
    () => systemIssuesService.listMessages(issueId as number),
    { enabled: !!issueId, staleTime: 10 * 1000 },
  )
}

export function useCreateIssueMessage(issueId: number) {
  const qc = useQueryClient()
  return useMutation(
    (payload: {
      content: string
      attachments?: SystemIssuePendingAttachment[]
    }) => systemIssuesService.createMessage(issueId, payload),
    {
      onSuccess: () => {
        qc.invalidateQueries(issueMessagesKey(issueId))
        qc.invalidateQueries(issueKey(issueId))
        qc.invalidateQueries(['system-issues', 'all'])
        qc.invalidateQueries(myIssuesKey)
      },
    },
  )
}
